<template>
  <span>
    <span :style="`color: rgb(${rgb.red},${rgb.green},${rgb.blue})`" style="padding-right: 0.4rem"><font-awesome-icon icon="square"/></span>
    <span>RGB({{ rgb.red }}, {{ rgb.green }}, {{ rgb.blue }})</span>
  </span>
</template>

<script>
  export default {
    name: 'RgbDisplay',
    props: ['rgb'],
  };
</script>

<style scoped>
</style>
